import { Duration } from 'luxon';

export const useDurationFormat = (ISODuration?: string) => {
  if (!ISODuration) return '';

  const duration = Duration.fromISO(ISODuration).shiftTo('hours', 'minutes');
  if (!duration.isValid) return '';

  if (duration.hours > 0 && duration.minutes > 0) {
    return duration.toFormat("h'h' mm'm'");
  } else if (duration.hours > 0) {
    return duration.toFormat("h'h'");
  } else {
    return duration.toFormat("m'm'");
  }
};
